export const atomicKeys = {
  currentDeviceSetting: 'currentDeviceSetting',
  currentDeviceCheck: 'currentDeviceCheck',
  currentSpeakerCheck: 'currentSpeakerCheck',
  currentCameraCheck: 'currentCameraCheck',
  companyInfo: 'companyInfo',
  loginInfo: 'loginInfo',
  settingFooterInfo: 'settingFooterInfo',
  videoLayout: 'videoLayout',
  interviewTime: 'interviewTime',
  externalApiUrl: 'externalApiUrl',
  checkLogInterviewer: 'checkLogInterviewer',
  isLoading: 'isLoading',
  deviceError: 'deviceError',
  meetingError: 'meetingError',
};

export const selectorKeys = {
  isCameraChecked: 'isCameraChecked',
  isSpeakerChecked: 'isSpeakerChecked',
  modalLayoutState: 'modalLayoutState',
  isLogin: 'isLogin',
  attendeeInfo: 'attendeeInfo',
  alreadyEnteredInterviewer: 'alreadyEnteredInterviewer',
};

export const paramKeys = {
  camera: 'camera',
};
